import styled from 'styled-components';

export const ChatBodyEndButton = styled.div`
  height: ${(props) => (props.device === 'mobile' ? '9vw' : '36px')};
  width: ${(props) => (props.device === 'mobile' ? 'fit-content' : 'fit-content')};
  font-size: ${(props) => (props.device === 'mobile' ? '4vw' : '14px')};
  background: #ffffff;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  padding: 4px 20px;
  border-radius: 4px;
  color: #666666;
`;

export const ChatBodyEndButtonVideo = styled.div`
  height: ${(props) => (props.device === 'mobile' ? '9vw' : '36px')};
  width: ${(props) => (props.device === 'mobile' ? 'fit-content' : 'fit-content')};
  font-size: ${(props) => (props.device === 'mobile' ? '4vw' : '14px')};
  background: ${(props) => props.$themecolor ?? '#3F5773'};

  margin-left: 5%;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  padding: 4px 20px;
  border-radius: 4px;
  color: #fff;
`;
